'use client'

import React, { useEffect } from 'react'
import dynamic from 'next/dynamic'
import { injectGatherFormScript } from '@dustin-web/microsite-baselayout/src/components/3rd-party-scripts/gather-form-script'
import { EditorialPageFragment } from '@contentsite/src/graphql/generated/graphql-types'
import { EditorialPageSchema } from '../../schemas/web-page-schema'
const Breadcrumbs = dynamic(() =>
  import('@dustin-web/microsite-components/src/breadcrumbs').then(mod => mod.Breadcrumbs)
)
const BreadcumbSchema = dynamic(() =>
  import('../../schemas/web-page-schema').then(mod => mod.BreadcumbSchema)
)

const hasForm = (body: string): boolean => {
  const formIDAttr = 'data-infunnelapps-form-id'
  return !!body?.includes(formIDAttr)
}

type Props = {
  page: EditorialPageFragment
  pageContent: React.ReactNode
}

const EditorialContent = ({ page, pageContent }: Props) => {
  const { breadcrumbs, dynamicBreadcrumbs } = page

  useEffect(() => {
    if (hasForm(page.body)) {
      setTimeout(() => {
        injectGatherFormScript()
        // Script injection must run only as a last operation due to scripts conflict
      }, 2500)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const dynamicBreadcrumbsEnabled =
    !page.body.replace(/<!--.*?-->/g, '').includes('c-breadcrumbs') && dynamicBreadcrumbs

  const formatedBreadcrumbs = breadcrumbs.map(breadcrumb => ({
    displayName: breadcrumb.displayName,
    url: breadcrumb.url,
    clientNavigationRoute: breadcrumb.url,
  }))

  return (
    <>
      {dynamicBreadcrumbsEnabled ? (
        <div className="container">
          <Breadcrumbs path={formatedBreadcrumbs} />
        </div>
      ) : (
        <BreadcumbSchema path={formatedBreadcrumbs} />
      )}
      <EditorialPageSchema page={page} />
      {pageContent}
    </>
  )
}

export default EditorialContent
